import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=ac270c88&scoped=true"
import script from "./ReportDetail.vue?vue&type=script&lang=js"
export * from "./ReportDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportDetail.vue?vue&type=style&index=0&id=ac270c88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac270c88",
  null
  
)

export default component.exports